export default __webpack_public_path__ + "static/media/equipe.6a33fac8.png";